import { FormEvent, useState } from 'react';
import { RegistrationContainer } from '@bumble/app/components/RegistrationContainer';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import {
  Alert,
  Box,
  Button,
  Divider,
  InputAdornment,
  TextField,
  Typography,
} from '@mui/material';
import { useMutation } from '@tanstack/react-query';
import { Link } from 'react-router-dom';

export const ResendVerification = () => {
  const api = useApi();
  const [email, setEmail] = useState('');
  const [success, setSuccess] = useState(false);

  const resendVerification = useMutation(api.resendVerificationApiV1ResendVerificationPost, {
    onSuccess() {
      setSuccess(true);
    },
    onError: (err: any) => {
      apiError(err);
    },
  });

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    resendVerification.mutate({ email });
  };

  if (success) {
    return (
      <RegistrationContainer>
        <Typography variant="h3" component="h1" mb={2}>
          Verify your email
        </Typography>
        <Alert severity="success" sx={{ textAlign: 'left', my: 5 }}>
          If an unverified account exists for this email address, a new verification email has been
          sent. Please check your inbox.
        </Alert>
        <Box py={6}>
          <Divider />
        </Box>
        <Button size="small" variant="text" component={Link} to="/login">
          Already have an account?
        </Button>
      </RegistrationContainer>
    );
  }

  return (
    <RegistrationContainer>
      <Typography variant="h3" component="h1" mb={2}>
        Verify your email
      </Typography>
      <Typography variant="body1" component="p" py={2} mb={2}>
        Enter your email address below and we&apos;ll send you a new verification link.
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Email Address"
          margin="normal"
          type="text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon />
              </InputAdornment>
            ),
          }}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Box mt={4}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            type="submit"
            disabled={email.length < 5 || resendVerification.isLoading}
          >
            Send Verification Email
          </Button>
        </Box>
      </Box>
      <Box py={6}>
        <Divider />
      </Box>
      <Button size="small" variant="text" component={Link} to="/login">
        Already have an account?
      </Button>
    </RegistrationContainer>
  );
};
